// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3aTJG","consentsList":"PatientConsents_consentsList__2CBc4","consentsListEmpty":"PatientConsents_consentsListEmpty__3TrxQ"};